import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-email-tags',
  imports: [CommonModule, FormsModule],
  templateUrl: './email-tags.component.html',
  styleUrls: ['./email-tags.component.scss']
})
export class EmailTagsComponent implements OnInit {
  @Input() emails: string[] = [];
  inputValue = '';

  @ViewChild('hiddenInput') inputRef!: ElementRef<HTMLInputElement>;
  @Output() emailListChange = new EventEmitter<{ emails: string[]; invalid: boolean }>();

  private emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  ngOnInit(): void {
      this.emitEmails();
  }

  focusInput() {
    this.inputRef.nativeElement.focus();
  }

  emitEmails() {
    this.emailListChange.emit({
      emails: this.emails,
      invalid: this.emails.length === 0
    });
  }

  addEmailsFromInput() {
    const parts = this.inputValue.split(/[\s,]+/).map(e => e.trim());
    let added = false;

    parts.forEach(email => {
      if (this.emailRegex.test(email) && !this.emails.includes(email)) {
        this.emails.push(email);
        added = true;
      }
    });

    this.inputValue = '';
    this.emitEmails();
  }

  onKeydown(event: KeyboardEvent) {
    if (['Enter', ',', ' '].includes(event.key)) {
      event.preventDefault();
      this.addEmailsFromInput();
    } else if (event.key === 'Backspace' && !this.inputValue) {
      this.emails.pop();
      this.emitEmails();
    }
  }

  onPaste(event: ClipboardEvent) {
    const text = event.clipboardData?.getData('text') || '';
    this.inputValue = text;
    this.addEmailsFromInput();
    event.preventDefault();
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
    this.emitEmails();
  }
}
